'use strict';

module.exports = require('./makeMakeHot');


//////////////////
// WEBPACK FOOTER
// ./~/react-hot-api/modules/index.js
// module id = 4
// module chunks = 0